<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="4" class="padding-r-0">
        <admin-shop @shop-change="handleShopChange"></admin-shop>
      </el-col>
      <el-col :span="20">
        <el-card >
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('shopSmsDetail.queryCondition') }}</span>
          </div>
          <el-form :inline="true" :model="aShopSmsDetailInfo.conditions" class="flex justify-start">
            <el-form-item>
              <el-input :placeholder="$t('shopSmsDetail.phonePlaceholder')" v-model="aShopSmsDetailInfo.conditions.link"
                clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="_queryAShopSmsDetailMethod">
                {{ $t('shopSmsDetail.query') }}
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <el-card class="margin-top">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('shopSmsDetail.sendRecords') }}</span>
          </div>
          <el-table :data="aShopSmsDetailInfo.details" style="width: 100%" border stripe>
            <el-table-column prop="detailId" :label="$t('shopSmsDetail.detailId')" align="center"></el-table-column>
            <el-table-column prop="shopName" :label="$t('shopSmsDetail.shopName')" align="center"></el-table-column>
            <el-table-column prop="smsContent" :label="$t('shopSmsDetail.smsContent')" align="center"></el-table-column>
            <el-table-column prop="link" :label="$t('shopSmsDetail.phoneNumber')" align="center"></el-table-column>
            <el-table-column prop="createTime" :label="$t('shopSmsDetail.sendTime')" align="center"></el-table-column>
          </el-table>

          <el-pagination @current-change="handleCurrentChange" :current-page="aShopSmsDetailInfo.conditions.page"
            :page-size="aShopSmsDetailInfo.conditions.row" layout="total, prev, pager, next"
            :total="aShopSmsDetailInfo.total"></el-pagination>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { listAShopSmsDetail } from '@/api/shopSms/shopSmsApi'
import AdminShop from '@/components/shop/adminShop'

export default {
  components: {
    AdminShop
  },
  data() {
    return {
      aShopSmsDetailInfo: {
        details: [],
        total: 0,
        conditions: {
          link: '',
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._listAShopSmsDetails()
  },
  methods: {
    handleShopChange(shop) {
      this.aShopSmsDetailInfo.conditions.shopId = shop.shopId
      this._listAShopSmsDetails()
    },
    handleCurrentChange(currentPage) {
      this.aShopSmsDetailInfo.conditions.page = currentPage
      this._listAShopSmsDetails()
    },
    async _listAShopSmsDetails() {
      try {
        const res = await listAShopSmsDetail(this.aShopSmsDetailInfo.conditions)
        this.aShopSmsDetailInfo.details = res.data
        this.aShopSmsDetailInfo.total = res.total
      } catch (error) {
        console.error('获取店铺短信详情失败:', error)
      }
    },
    _queryAShopSmsDetailMethod() {
      this.aShopSmsDetailInfo.conditions.page = 1
      this._listAShopSmsDetails()
    }
  }
}
</script>

<style scoped>
.padding-r-0 {
  padding-right: 0;
}

.ibox {
  margin-bottom: 20px;
}
</style>